import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AgreementToPick } from 'src/app/models/dtos/agreement-to-pick-dto';
import { WorkerAgreementStatusEnum } from 'src/app/models/enums/worker-agreement-status-enum';

@Component({
  selector: 'app-agreement-picker',
  templateUrl: './agreement-picker.component.html',
  styleUrls: ['./agreement-picker.component.scss'],
  standalone: false
})
export class AgreementPickerComponent implements OnChanges, OnDestroy {
  private formBuilder = inject(UntypedFormBuilder);

  agreementForm: UntypedFormGroup;

  @Input() agreements: AgreementToPick[];
  @Input() set agreementSelection(AgreementToPick: AgreementToPick) {

    const agreement = this.agreements?.find(a => a.Id === AgreementToPick.Id);

    if (agreement) {
      const isActive = this.isStillActive(agreement);

      this.isCheckedFormControl.setValue(!isActive);
      this.agreementFormControl.setValue(agreement);
    }
  };
  @Output() agreementSelectionChange: EventEmitter<AgreementToPick> = new EventEmitter();

  private get agreementFormControl() {
    return this.agreementForm.get('agreement')
  }

  private get isCheckedFormControl() {
    return this.agreementForm.get('isChecked')
  }

  private readonly unsubscribe$ = new Subject<void>();


  constructor() {
    this.agreementForm = this.buildAgreementFormGroup();
    this.onAgreementChange();
    this.onIsCheckedChange();
  }

  ngOnChanges(): void {
    if (!!this.agreements && this.agreements.length && !this.agreementFormControl.value) {
      this.setAgreementValue();
    }
  }

  private setAgreementValue() {
    this.agreementFormControl.setValue(
      this.agreements.find((a) => this.isCheckedFormControl.value ? !this.isStillActive(a) : this.isStillActive(a)));
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  filterAgreements = (item: AgreementToPick) => this.isCheckedFormControl.value ? !this.isStillActive(item) : this.isStillActive(item);

  private isStillActive = (item: AgreementToPick) => item.AgreementStatusId === WorkerAgreementStatusEnum.Active || (item.AgreementStatusId === WorkerAgreementStatusEnum.Terminated && item.AgreementTerminationEndDate >= moment().toDate())

  private buildAgreementFormGroup = () =>
    this.formBuilder.group({
      agreement: [null, Validators.required],
      isChecked: [false],
    });

  private onIsCheckedChange = () =>
    this.isCheckedFormControl
      .valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => { this.setAgreementValue() });

  private onAgreementChange = () =>
    this.agreementFormControl
      .valueChanges.pipe(takeUntil(this.unsubscribe$))
      .subscribe((agreement) => this.agreementSelectionChange.emit(agreement));
}
